import { observer } from 'mobx-react-lite'
import { SunIcon } from '@heroicons/react/24/outline'

import { DebugButton } from './DebugButton'

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        updateColorScheme: () => void
    }
}

export const ToggleColorScheme = observer(() => {
    return (
        <DebugButton
            Icon={SunIcon}
            onClick={() => {
                if (localStorage.colorScheme === 'light') {
                    localStorage.colorScheme = 'dark'
                } else {
                    localStorage.colorScheme = 'light'
                }
                window.updateColorScheme()
            }}
        />
    )
})
